module.exports = __webpack_public_path__ + "img/Art03-20130078-001.16d9e439.jpg";